import { getDolarValue, getUFValue } from "../exchangeRateService";

// Convierte un monto a moneda local del país (CLP o PEN) usando dólar/UF histórico.
// USD → monto * getDolarValue(fecha, pais). UF → monto * getUFValue(fecha).
// CLP/PEN se devuelven sin cambios.
export const toMonedaLocal = (monto, moneda, fecha, pais) => {
  if (!monto) return 0;
  if (moneda === "USD") return Math.round(monto * getDolarValue(fecha, pais));
  if (moneda === "UF") return Math.round(monto * getUFValue(fecha));
  return monto;
};

// Convierte un monto a la moneda de display elegida por el usuario.
// Caminos:
//   - origen === monedaSaldo            → identidad
//   - monedaSaldo === monedaPrincipal   → toMonedaLocal(origen)
//   - monedaSaldo === "USD"             → si origen=USD identidad, si no monto / getDolarValue
//   - cualquier otro                    → monto sin cambios
export const toDisplayCurrency = (monto, monedaOrigen, fecha, { monedaSaldo, monedaPrincipal, pais }) => {
  if (!monto) return 0;
  const origen = monedaOrigen || monedaPrincipal;
  if (origen === monedaSaldo) return monto;
  if (monedaSaldo === monedaPrincipal) return toMonedaLocal(monto, origen, fecha, pais);
  if (monedaSaldo === "USD") {
    if (origen === "USD") return monto;
    const rate = getDolarValue(fecha, pais);
    return rate > 0 ? Math.round(monto / rate) : 0;
  }
  return monto;
};
